import React, { useState } from "react";
import moment from "moment-timezone";
import { useDispatch } from "react-redux";

import { Moment } from "moment";
import { DatePicker } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";

import { EditableContainerWithActions } from "../../../../components/ui";
import { useAdminProviderDataContext, useDiscountsContext } from "../../../../context";
import { APIDiscounts } from "../../../../api";
import { DiscountCodeState } from "../../../../api/discounts/index.types";
import { DATE_FORMAT } from "../../../../constants";
import { discountCodesActions } from "../../../../reducers/discountCodes";

interface IProps {
  discount: DiscountCodeState;
}

const isExpired = (date: string | null) =>
  date ? moment().tz("America/Chicago").diff(date, "days") <= 0 : "";

const ChangeDiscountCodeExpires = ({ discount }: IProps): React.ReactElement => {
  const dispatch = useDispatch();

  const { sortBy, search, page, limit } = useDiscountsContext();
  const {
    user: { allowed_features },
  } = useAdminProviderDataContext();

  const [selectedDate, handleDateChange] = useState<string | null>(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isShowAlert, setIsShowAlert] = useState(false);
  const isValidDateValue = moment(discount.expires).isValid();
  const sellValue = isValidDateValue && discount.expires;

  const handleApply = async () => {
    try {
      setIsUpdating(true);
      await APIDiscounts.updateDiscountCodeRequest({
        expires: selectedDate,
        code_id: discount.id,
        editableValueKeyName: "expires",
      });

      const data = {
        limit,
        page,
        contains: search,
        sortBy,
        inactive: true,
      };
      const response = await APIDiscounts.getDiscountCodesRequest(data);
      const responseData = response.data;
      dispatch(discountCodesActions.fetchSuccess(responseData));
    } catch (error) {
      setIsShowAlert(true);
    } finally {
      setIsUpdating(false);
    }
  };
  const isAllowedToSave =
    moment(selectedDate).isValid() &&
    moment().tz("America/Chicago").diff(selectedDate, "days") <= 0;

  return (
    <EditableContainerWithActions
      renderComponent={() => (
        <DatePicker
          value={selectedDate || (isValidDateValue ? discount.expires : null)}
          inputFormat={DATE_FORMAT}
          onChange={(date: Moment | null) =>
            handleDateChange(date ? date.format(DATE_FORMAT) : null)
          }
          renderInput={(params) => <TextField {...params} />}
          disablePast
        />
      )}
      isEditable={allowed_features.change_discount_code_expiration}
      tableDataCellStyles={{
        ...(!isExpired(discount.expires) && { color: "gray" }),
      }}
      defaultValue={sellValue}
      isChanged={isAllowedToSave && !!selectedDate}
      handleApply={handleApply}
      isUpdating={isUpdating}
      isShowAlert={isShowAlert}
      setIsShowAlert={setIsShowAlert}
    />
  );
};

export default ChangeDiscountCodeExpires;
